import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import IUser from '../../../_interfaces/IUser';
import { readRouteParam } from '../../../_utils/route-param.utils';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormUserLoginPageComponent } from '../../../components/forms/form-user-login-page/form-user-login-page.component';

@Component({
  selector: 'app-admin-user-landing',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminFormLayoutComponent,
    AdminStatePanelComponent,
    FormUserLoginPageComponent,
  ],
  templateUrl: './admin-user-landing.component.html',
  styleUrl: './admin-user-landing.component.scss',
})
export class AdminUserLandingComponent implements OnInit {
  public customersId = 0;
  public usersId = 0;
  public user: IUser | null = null;
  public loading = true;
  public hasError = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  readonly reload = (): void => {
    this.load(false);
  };

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.usersId = readRouteParam(this.route, 'users_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    if (!this.customersId || !this.usersId) {
      this.hasError = true;
      this.loading = false;
      return;
    }

    this.loading = true;
    this.hasError = false;
    let hasResolverData = false;

    if (fromResolver) {
      const user = (this.route.parent?.snapshot.data['user'] || null) as
        | IUser
        | null;
      if (user) {
        this.user = user;
        this.loading = false;
        hasResolverData = true;
      }
    }

    this.loader.loadUser(this.customersId, this.usersId).subscribe({
      next: (user) => {
        this.user = user;
        this.hasError = !user;
        this.loading = false;
      },
      error: () => {
        if (hasResolverData) {
          return;
        }
        this.hasError = true;
        this.loading = false;
      },
    });
  }
}
